function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M282.868,56.803H204.27l6.877-6.158c0.505-0.452,0.957-0.958,1.35-1.509c10.05-14.091,6.762-33.731-7.331-43.781 c-6.72-4.792-15.185-6.475-23.225-4.612c-8.041,1.861-14.906,7.09-18.837,14.345l-13.434,24.799l-13.434-24.799 c-3.931-7.256-10.797-12.486-18.837-14.346c-8.042-1.862-16.507-0.18-23.225,4.612c-14.091,10.05-17.38,29.69-7.331,43.781 c0.394,0.552,0.847,1.058,1.35,1.509l6.877,6.158H16.474c-5.07,0-9.18,4.11-9.18,9.18v58.204c0,5.07,4.11,9.18,9.18,9.18h2.432 V290.16c0,5.07,4.11,9.18,9.18,9.18h243.17c5.07,0,9.18-4.11,9.18-9.18V133.366h2.432c5.07,0,9.18-4.11,9.18-9.18V65.983 C292.048,60.913,287.937,56.803,282.868,56.803z M179.248,23.833c1.446-2.671,3.873-4.519,6.833-5.204 c0.802-0.186,1.605-0.277,2.401-0.277c2.142,0,4.221,0.664,6.024,1.95c2.834,2.021,4.71,5.023,5.285,8.457 c0.525,3.14-0.096,6.293-1.751,8.977l-21.295,19.067h-15.357L179.248,23.833z M99.549,28.76c0.574-3.432,2.451-6.436,5.286-8.457 c2.473-1.764,5.463-2.359,8.425-1.673c2.959,0.684,5.386,2.533,6.833,5.204l17.86,32.969h-15.357l-21.296-19.067 C99.645,35.053,99.024,31.898,99.549,28.76z M115.508,280.981H37.265V133.367h78.243V280.981z M165.472,280.981h-31.604V133.367 h31.604V280.981z M262.076,280.981h-78.243V133.367h78.243V280.981z M273.688,115.007H25.653V75.163h248.034V115.007z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgGiftTwo = function SvgGiftTwo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 299.34 299.34",
    style: {
      fill: "#f8c0c4"
    },
    xmlSpace: "preserve",
    width: "80px",
    height: "80px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGiftTwo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gift-two.a571fc1e.svg";
export { ForwardRef as ReactComponent };